import { Link } from "react-router-dom";

import { KanplaLogoNew } from "~/components";
import { NetworkStatus } from "~/components/network-status/network-status";
import { HelpCenterButton } from "~/components/home/help-center-button";
import { ProfileBadge } from "~/components/home/profile-badge";
import { authActions } from "~/providers/store/auth";
import { basketActions } from "~/providers/store/basket";
import { kioskActions } from "~/stores/kiosk-session/actions";
import { type Till } from "~/api/tills/types";

type HomeHeaderProps = {
  till: Till;
  profileName: string;
};

export const HomeHeader = ({ till, profileName }: HomeHeaderProps) => {
  const handleLogout = () => {
    if (!till) return;

    if (till.type === "kiosk") {
      kioskActions.session.reset();
    } else {
      basketActions.reset();
      basketActions.resetDiningOption();
    }

    authActions.logoutProfile();
  };

  return (
    <div className="flex w-full items-center justify-center">
      <div className="flex flex-1 justify-start">
        <KanplaLogoNew variant="dark" className="!h-5 !w-auto" />
      </div>

      <div className="flex justify-center">
        <Link to="/support">
          <HelpCenterButton />
        </Link>
      </div>

      <div className="flex flex-1 items-center justify-end gap-3">
        <NetworkStatus />
        <ProfileBadge name={profileName} onLogout={handleLogout} />
      </div>
    </div>
  );
};
